import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import i18n from '@yandex-int/i18n';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { CheckIcon } from 'client/blocks/icons/CheckIcon';
import { routes } from 'client/lib/routes';
import { AliceAgentAppListItem } from 'client/model/aliceAgentApp';
import * as keyset from 'i18n/AliceAgentAppForm';
import moment from 'moment';

import styles from './AliceAgentAppCard.module.scss';

const t = i18n(keyset);

interface Props {
    item: AliceAgentAppListItem;
}

export const AliceAgentAppCard: FC<Props> = ({ item }) => {
    const isInternal = item.type === 'aliceInternalAgentApp';
    const typeLabel = isInternal ? t('card-type-internal') : t('card-type-external');
    const publishedDate = item.firstPublishedAt ? moment(item.firstPublishedAt).format('DD.MM.YY') : null;
    const firstLetter = item.name.trim().slice(0, 1).toUpperCase() || '?';
    const linkTo = isInternal ? routes.app.aliceAgentApp(item.skillId) : routes.app.aliceExternalApp(item.skillId);

    return (
        <ErrorBoundary>
            <Link to={linkTo}>
                <div className={styles.card}>
                    <div className={styles.contentRow}>
                        <h3 className={styles.title}>{item.name}</h3>
                        {item.logoUrl ? (
                            <div className={styles.iconPreviewContainer}>
                                <img className={styles.iconShadow} src={item.logoUrl} alt="" />
                                <img className={styles.iconImage} src={item.logoUrl} alt="" />
                            </div>
                        ) : (
                            <div className={styles.iconPlaceholder}>{firstLetter}</div>
                        )}
                    </div>
                    <div className={styles.statusRow}>
                        {item.onAir && publishedDate ? (
                            <div className={styles.publishedBlock}>
                                <CheckIcon />
                                <span className={styles.publishedBlockText}>
                                    {t('card-published-on', { date: publishedDate })}
                                </span>
                            </div>
                        ) : (
                            <span />
                        )}
                        <div className={styles.channelIcon}>{typeLabel}</div>
                    </div>
                </div>
            </Link>
        </ErrorBoundary>
    );
};
